export const CONTENT_VERIFICATION_STATUSES = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
};

export const CONTENT_VERIFICATION_STATUS_OPTIONS = [
  { value: CONTENT_VERIFICATION_STATUSES.VERIFIED, label: 'Verified' },
  { value: CONTENT_VERIFICATION_STATUSES.UNVERIFIED, label: 'Unverified' },
];
